export const PaymentProfileTypes = {
  stripeConnectAu: { label: 'Stripe Connect Australia' },
  stripeConnectAuAbacus: { label: 'Stripe Connect Abacus Australia' },
  stripeConnectNzAbacus: { label: 'Stripe Connect Abacus New Zealand' },
  abacusCheckout: { label: 'Abacus Checkout' },
  abacusCheckoutStripeComposite: { label: 'Abacus Checkout Stripe Composite' },
  abacusCheckoutSpi: { label: 'Abacus Checkout Spi' },
  abacusCheckoutSpiStripeComposite: { label: 'Abacus Checkout Spi Stripe Composite' },
  abacusCardless: { label: 'Abacus Cardless' },
  abacusWorldpayAu: { label: 'Abacus Worldpay Australia' },
  abacusWorldpayNz: { label: 'Abacus Worldpay New Zealand' },
  abacusWorldpayStripeCompositeAu: { label: 'Abacus Worldpay Stripe Composite Australia' },
  abacusWorldpayStripeCompositeNz: { label: 'Abacus Worldpay Stripe Composite New Zealand' },
  abacusFiservStripeComposite: { label: 'Abacus Fiserv Stripe Composite' },
  abacusFiserv: { label: 'Abacus Fiserv' },
  abacusFiservNz: { label: 'Abacus Fiserv New Zealand' },
  abacusFiservNzStripeComposite: { label: 'Abacus Fiserv New Zealand Stripe Composite' },
  abacusReslyNzStripeConnect: { label: 'Abacus Resly New Zealand Stripe Connect' },
  abacusOnUsAu: { label: 'Abacus On Us Australia' },
  abacusOnUsNz: { label: 'Abacus On Us New Zealand' },
  abacusOnUsHk: { label: 'Abacus On Us Hong Kong' },
  abacusOnUsSg: { label: 'Abacus On Us Singapore' },
  abacusMock: { label: 'Abacus Mock' },
};
